var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicGAppArrowDown = function SvgIcLogicGAppArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15 20.4-6.9-6.9c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l5.5 5.5 5.5-5.5c.4-.4 1-.4 1.4 0s.4 1 0 1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h30v30H0z"
  })));
};
export default SvgIcLogicGAppArrowDown;